// type rafce to get app imort and export template 
import React from 'react'
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Skills from './components/skills/Skills'
import Portfolio from './components/portfolio/Portfolio'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'
import Gitt from './components/git/Gitt'


const App = () => {
  return (
    <div>
      <Footer />
      <Header />
      <Nav />
      <About />
      <Skills />
      <Portfolio />
      <Gitt/>
      <Contact />
      
    </div>
  )
}

export default App